import { Link } from "react-router-dom";
import Photo from "./Photo";
import { categoryLabel } from "../../data/salon";
import { duration, finalPrice, toman, faPercent } from "../../lib/format";
import { useBooking } from "../../lib/booking";
import { Stars } from "./Bits";
import "./ui.css";

export default function ServiceCard({ service, compact = false }) {
  const booking = useBooking();
  const added = booking.has(service.id);

  return (
    <article className={`scard${compact ? " scard--compact" : ""}`}>
      <Link to={`/services/${service.slug}`} className="scard__media">
        <Photo
          src={service.photo}
          alt={service.name}
          ratio={compact ? "4 / 3" : "4 / 3.4"}
          className="ph--hover"
          tint="soft"
        />

        {service.discount > 0 && (
          <span className="badge badge--sale scard__badge">
            {faPercent(service.discount)} تخفیف
          </span>
        )}
        {service.tags.includes("signature") && !service.discount && (
          <span className="badge badge--violet scard__badge">امضای رُز</span>
        )}
      </Link>

      <div className="scard__body">
        <span className="scard__cat">{categoryLabel(service.category)}</span>

        <h3 className="scard__name">
          <Link to={`/services/${service.slug}`}>{service.name}</Link>
        </h3>

        {!compact && <p className="scard__short">{service.short}</p>}

        <div className="scard__meta">
          <span>{duration(service.duration)}</span>
          <Stars rating={service.rating} />
        </div>

        <div className="scard__foot">
          <span className="scard__price">
            {service.discount > 0 && <s className="scard__was">{toman(service.price)}</s>}
            {toman(finalPrice(service))}
          </span>

          <button
            type="button"
            className={`scard__add${added ? " is-added" : ""}`}
            onClick={() => (added ? booking.setOpen(true) : booking.add(service))}
            aria-label={added ? `${service.name} در سبد نوبت است` : `افزودن ${service.name} به سبد نوبت`}
          >
            {added ? "✓" : "+"}
          </button>
        </div>
      </div>
    </article>
  );
}
